import { Component, OnInit, Input } from '@angular/core';
import { Call } from 'src/app/models/call.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-list-call-item-client',
  templateUrl: './list-call-item-client.component.html',
  styleUrls: ['./list-call-item-client.component.scss']
})
export class ListCallItemClientComponent implements OnInit {
  @Input() calls: Call[];

  public displayedColumns: string[] = [
    'number', 'status', 'business', 'business_user', 'user', 'type', 'options'
  ];

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  public classesByState(call: Call): string {
    switch (call.status) {
      case 'T': return 'bg-attending';
      case 'P': return 'bg-pending';
      case 'R': return 'bg-solved';
      case 'F': return 'bg-closed';
      case 'C': return 'bg-canceled';
      default: return 'bg-waiting';
    }
  }

  public goToCall(call: Call) {
    this.router.navigate([`/cliente/chamados/${ call.identifier }`])
  }
}
